import BookingInfo from './BookingInfo';
import GuestInfo from './GuestInfo';

export default class GuestFormRequest {

    constructor() {
        this.matchRequestId = null;
        this.scoreReference = null;
        this.scoreStatus = null;
        this.guestInfo = null;
        this.bookingInfo = null;
        this.hostEmail = null;
        this.status = null;
        this.idVerificationRequired = null;
        this.selfieVerificationRequired = null;
    }

    static create(rawData, guestInfo, bookingInfo) {
        const guestFormRequest = new GuestFormRequest();

        // form data
        guestFormRequest.matchRequestId = rawData.matchRequestId;
        guestFormRequest.scoreReference = rawData.scoreReference;
        guestFormRequest.scoreStatus = rawData.scoreStatus;
        guestFormRequest.hostEmail = rawData.hostEmail;
        guestFormRequest.status = rawData.status;
        guestFormRequest.idVerificationRequired = rawData.idVerificationRequired;
        guestFormRequest.selfieVerificationRequired = rawData.selfieVerificationRequired;

        // guest data
        guestFormRequest.guestInfo = GuestInfo.create(guestInfo);

        // booking data
        guestFormRequest.bookingInfo = BookingInfo.create(bookingInfo);

        return guestFormRequest;
    }

    cleanUpNullFields() {
        this.cleanUpField("matchRequestId");
        this.cleanUpField("scoreReference");
        this.cleanUpField("scoreStatus");
        this.cleanUpField("guestInfo");
        this.cleanUpField("bookingInfo");
        this.cleanUpField("hostEmail");
        this.cleanUpField("status");
        this.cleanUpField("idVerificationRequired");
        this.cleanUpField("selfieVerificationRequired");
    }

    cleanUpField(field) {
        if(this[field] == null) {
            delete this[field];
        }
    }
}
